import React, { useEffect, useState } from "react";
import {
  getFormContent,
  getSingleSurvey,
  updateFormContent,
  surveyResultPreview,
  sharePreviewLink,
  addFormContent,
  imageUpload,
} from "../../../api/services/services";
import backArrow from "../../../imgs/BackArrow.svg";
import MainTemplate from "../../templates/MainTemplate";
import PremiumPageLayout from "../../templates/PremiumPageLayout";
import PremiumCard from "../../molecules/PremiumCard";
import SectionHeader from "../../molecules/SectionHeader";
// import "./style.css";
import { useNavigate } from "react-router-dom";
import { Button, Snackbar } from "@mui/material";
import Typography from "@mui/material/Typography";
import { Row, Col } from "react-bootstrap";
import MuiAlert from "@mui/material/Alert";
import { Bucket } from "../../../api/config/apiConfig";
import ContactDetailField from "../../molecules/ContactDetailField";
import DynamicText from "../../molecules/DynamicText";
import DynamicCheckbox from "../../molecules/DynamicCheckbox";
import { useParams } from "react-router-dom";
import generatePDF, { Resolution, Margin } from "react-to-pdf";
import html2pdf from "html2pdf.js";
import PackingRequestPageDownload from "./ClientSide/download";
import PrintComponent from "../PrintComponent";
import editIcn from "../../../imgs/edit.png";
import trashIcn from "../../../imgs/trash.png";
import LoadingModal from "../../molecules/LoadingModal";
import moment from "moment";
import MySignatureCanvas from "../../molecules/signature_canvas";
import ShareWithClientsModal from "../../molecules/ShareWithClients";
import { sendSuperAdminVerificationForEdit } from "../PrebidAgreement/creation/service";
import SuperAdminVerifationModal from "../../molecules/SuperAdminVerifationModal";
import PersonIcon from '@mui/icons-material/Person';
import InventoryIcon from '@mui/icons-material/Inventory';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import DescriptionIcon from '@mui/icons-material/Description';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import HomeIcon from '@mui/icons-material/Home';

const PackingRequestPage = () => {
  const { surveyId, id, flg } = useParams();
  const [surveyData, setSurveyData] = useState(null);
  const navigate = useNavigate();

  const [formContentId, setFormContentId] = useState("");
  const [isEdit, setIsEdit] = useState(flg == "1" ? true : false);

  const [isLoading, setIsLoading] = useState(false);
  const [formContent, setFormContent] = useState({
    customerName: "",
    date: "",
    packingAddress: "",
    packingDate: "",
    packingTime: "",
    permissions: false,
    adviseRequirement: "",
    firstPriority: "",
    secondPriority: "",
    thirdPriority: "",
    packUpSuitable: false,
    suggestions: "",
    officeInstructions: "",
    clientSign: "",
    clientEmail: "",
    moveCordinatorSign: "",
  });

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [mediaKeysToSend, setMediaKeysToSend] = useState([]);
  const [mediaKeysToRemove, setMediaKeysToRemove] = useState([]);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [isSignCanvas, setSignCanvas] = useState(false);

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  //
  const getSurveyPreview = () => {
    surveyResultPreview(surveyId)
      .then((response) => {
        setSurveyData(response?.data?.data?.surveyDetail);
        let values = { ...formContent };
        values.packingAddress = `${response?.data?.data?.surveyDetail?.loadPlaceStAddress}, ${response?.data?.data?.surveyDetail?.loadPlaceCity}, ${response?.data?.data?.surveyDetail?.loadPlaceCountry}`;
        values.customerName = `${response?.data?.data?.surveyDetail?.name}`;
        values.clientEmail = `${response?.data?.data?.surveyDetail?.email}`;
        setFormContent(values);
      })
      .catch((error) => {
        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }
      });
  };

  //
  const getSurvey = () => {
    getSingleSurvey(surveyId)
      .then((response) => {
        if (response?.data?.data?.status == "submitted") getSurveyPreview();
        else {
          setSurveyData(response?.data?.data);
          let values = { ...formContent };
          values.packingAddress = `${response?.data?.data?.loadPlaceStAddress}, ${response?.data?.data?.loadPlaceCity}, ${response?.data?.data?.loadPlaceCountry}`;
          values.customerName = `${response?.data?.data?.name}`;
          values.clientEmail = `${response?.data?.data?.email}`;
          setFormContent(values);
        }
      })
      .catch((error) => {
        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }
      });
  };

  //
  const addContent = () => {
    setIsLoading(true);
    const body = {
      formId: id,
      surveyId: surveyId,
      content: formContent,
      mediaKeys: mediaKeysToSend,
    };
    addFormContent(body)
      .then(() => {
        setSnackbarMessage("Packing Request Form has been added successfully!");
        setOpenSnackbar(true);
        navigate(-1);

        setIsLoading(false);
        setMediaKeysToSend([]);
        setMediaKeysToRemove([]);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setIsLoading(false);
      });
  };

  //
  const updateContent = () => {
    setIsLoading(true);
    const body = {
      formId: id,
      surveyId: surveyId,
      content: formContent,
      mediaKeys: mediaKeysToSend,
      removedMediaKeys: mediaKeysToRemove,
    };
    updateFormContent(body, formContentId)
      .then((res) => {
        setSnackbarMessage(
          "Packing Request Form has been updated successfully!"
        );
        setOpenSnackbar(true);
        getContent();
        setIsEdit(false);

        setIsLoading(false);
        setMediaKeysToSend([]);
        setMediaKeysToRemove([]);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setIsLoading(false);
      });
  };

  //
  const getContent = () => {
    setIsLoading(true);
    setMediaKeysToSend([]);
    setMediaKeysToRemove([]);
    getFormContent(id, surveyId)
      .then((res) => {
        setFormContentId(res.data.data.uuid);
        setFormContent(res.data.data.content);
        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (flg == "1") getSurvey();
    else getContent();
  }, []);

  const [show, setShow] = useState(false);
  const options = {
    // resolution: Resolution.HIGH,
    page: {
      // margin is in MM, default is Margin.NONE = 0
      margin: Margin.SMALL,
      // default is 'A4'
      format: "letter",
      // default is 'portrait'
      orientation: "portrait",
    },
    canvas: {
      // default is 'image/jpeg' for better size performance
      mimeType: "image/png",
      qualityRatio: 1,
    },
    overrides: {
      pdf: {
        compress: true,
      },
    },
  };

  //
  const generatePdf = () => {
    if (window.innerWidth <= 768) {
      if (typeof setSnackbarMessage !== "undefined" && typeof setOpenSnackbar !== "undefined") {
        setSnackbarMessage("For a good experience, please use a desktop screen");
        setOpenSnackbar(true);
      } else {
        alert("For a good experience, please use a desktop screen");
      }
      return;
    }

    setShow(true);

    setTimeout(() => {
      const content = document.getElementById("content-to-convert"); // Replace with the ID of the element you want to convert to PDF

      const currentDateTime = new Date();
      const filename = `survey_${currentDateTime.toISOString()}.pdf`;

      const pdfOptions = {
        margin: 5,
        filename: filename,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "portrait",
        }, // Set the page size here
      };

      let temp = html2pdf().from(content).set(pdfOptions).outputPdf();
      temp.save(filename);

      setShow(false);
    }, 3500);
  };

  const [downloadText, setDownloadText] = useState("download");

  const getTargetElement = () => document.getElementById("content-id");

  const [isShare, setIsShare] = useState(false);

  //
  const shareWithClient = (data) => {
    let ems = [];
    let emsInd = 0;
    data.map((dt) => {
      if (dt.trim().length != 0) {
        ems[emsInd] = dt;
        emsInd++;
      }
    });

    setIsLoading(true);
    const body = {
      surveyId: surveyId,
      formId: id,
      emails: ems,
      formRoute: "packing-request-form-preview",
    };
    sharePreviewLink(body)
      .then(() => {
        setSnackbarMessage(
          "Packing Request Form has been shared with client successfully!"
        );
        setOpenSnackbar(true);

        setIsLoading(false);
        setIsShare(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setIsLoading(false);
      });
  };

  const printAction = () => {
    const tempTitle = document.title;
    const newTitle = `Packing-Request-${formContent?.customerName || 'Document'}-${moment().format("DD.MM.YYYY")}`;
    document.title = newTitle;
    
    // Standardized delay for print and title restoration
    setTimeout(() => {
      window.print();
      setTimeout(() => {
        document.title = tempTitle;
      }, 2000);
    }, 500);
  };

  const [uploadText, setUploadText] = useState("Upload Sign");

  //
  const uploadFile = async (file) => {
    setIsLoading(true);

    handleOpen();
    setUploadText("Uploading...");

    const fd = new FormData();
    fd.append("image", file);

    imageUpload(fd)
      .then((res) => {
        let values = { ...formContent };
        if (formContent.moveCordinatorSign?.trim()?.length != 0) {
          let dlt = [...mediaKeysToRemove];
          dlt.push(formContent.moveCordinatorSign);
          setMediaKeysToRemove(dlt);
        }

        values.moveCordinatorSign = res?.data?.data?.key;

        setFormContent(values);

        let md = [...mediaKeysToSend];
        md.push(res?.data?.data?.key);
        setMediaKeysToSend(md);

        setIsLoading(false);
        setUploadText("Upload Sign");
        handleClose();
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setUploadText("Upload Sign");

        setIsLoading(false);
        handleClose();
      });
  };

  const [isVerified, setIsVerified] = useState(false);
  const [isEditLoading, setIsEditLoading] = useState(false);

  const sendEditRequestToAdmin = () => {
    setIsEditLoading(true);
    sendSuperAdminVerificationForEdit()
      .then((response) => {
        setIsVerified(true);
        setIsEditLoading(false);
      })
      .catch((error) => {
        setIsVerified(false);
        setIsEditLoading(false);
      });
  };

  // Actions for the page header
  const pageActions = (
    <>
      {!isEdit && (
        <Button
          variant="contained"
          onClick={() => sendEditRequestToAdmin()}
          disabled={isEditLoading}
          startIcon={<NoteAltIcon />}
           style={{ 
            textTransform: "none", 
            borderRadius: "10px", 
            padding: "10px 28px",
            fontWeight: 600,
            backgroundColor: "#1976d2",
            boxShadow: "0 4px 12px rgba(25, 118, 210, 0.2)"
          }}
        >
          Edit
        </Button>
      )}

      {!isEdit && (
        <Button
           variant="outlined"
          onClick={() => setIsShare(true)}
          disabled={isLoading}
           style={{ 
            textTransform: "none", 
            borderRadius: "10px", 
            padding: "10px 28px",
            fontWeight: 600,
            border: "2px solid #e2e8f0",
            color: "#4a5568"
          }}
        >
          Share
        </Button>
      )}

      {isEdit && flg == "2" && (
        <Button
          variant="outlined"
          color="error"
           onClick={() => {
            getContent();
            setIsEdit(false);
          }}
          disabled={isLoading}
           style={{ textTransform: "none", borderRadius: "10px", fontWeight: 600, padding: "10px 28px", border: "2px solid" }}
        >
          Cancel
        </Button>
      )}

      {isEdit && (
        <Button
          variant="contained"
           onClick={() => {
            if (flg == "1") addContent();
            else updateContent();
          }}
          disabled={isLoading}
           style={{ 
            textTransform: "none", 
            borderRadius: "10px", 
            padding: "10px 32px",
            fontWeight: 600,
            backgroundColor: "#1976d2",
            boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)"
          }}
        >
          Save
        </Button>
      )}

      {!isEdit && (
        <Button
          variant="contained"
          onClick={() => printAction()}
          disabled={isLoading}
          startIcon={<DescriptionIcon />}
           style={{ 
            textTransform: "none", 
            borderRadius: "10px", 
            padding: "10px 28px",
            fontWeight: 600,
            backgroundColor: "#2d3748",
             boxShadow: "0 4px 12px rgba(45, 55, 72, 0.2)"
          }}
        >
          Save as PDF
        </Button>
      )}
    </>
  );

  return (
    <>
      <PremiumPageLayout 
        title="Packing Request Form" 
        actions={pageActions}
        onBack={() => navigate(-1)}
      >
        <PremiumCard>
          {/* Section 1: Customer Details */}
          <SectionHeader 
            title="Customer Details" 
            icon={<PersonIcon />} 
            iconBg="#e3f2fd"
            iconColor="#1976d2"
          />
          <div className="no-print mb-4">
            <div className="contact-detail d-flex mt-2 ">
              {/* left col */}
              <div className={`left-col w-50 text-start`}>
                <Typography variant="body1" gutterBottom>
                  <ContactDetailField
                    label="Customer Name:"
                    isEdit={isEdit}
                    type="text"
                    minWidth={"170px"}
                    value={formContent?.customerName}
                    onChange={(e) => {
                      let values = { ...formContent };
                      values.customerName = e.target.value;
                      setFormContent(values);
                    }}
                    disabled
                  />
                  <ContactDetailField
                    label="Date"
                    isEdit={isEdit}
                    type="date"
                    minWidth={"170px"}
                    value={formContent?.date}
                    onChange={(e) => {
                      let values = { ...formContent };
                      values.date = e.target.value;
                      setFormContent(values);
                    }}
                  />
                </Typography>
              </div>
            </div>
          </div>
          
          {/* Section 2: Packing Address */}
           <SectionHeader 
            title="Packing Address" 
            icon={<HomeIcon />} 
            iconBg="#e0f2f1"
            iconColor="#00695c"
          />
          <div className="mt-4 pe-1 no-print mb-4">
            <Typography variant="body1" className="text-start" gutterBottom>
              <DynamicText
                label="Packing Address"
                textAreaLabel="Packing Address"
                isEdit={isEdit}
                value={formContent?.packingAddress}
                onChange={(e) => {
                  let values = { ...formContent };
                  values.packingAddress = e.target.value;
                  setFormContent(values);
                }}
              />
            </Typography>
          </div>
         
         {/* Section 3: Priority Items */}
           <SectionHeader 
            title="Packing Priorities & Instructions" 
            icon={<PriorityHighIcon />} 
            iconBg="#fff3e0"
            iconColor="#e65100"
          />
         
          <div className="no-print">
            <div className="mt-4 pe-1 d-flex justify-content-start">
              <p className="mb-2">
                <b>
                  Which dates and time suits you to start packing of your goods?
                </b>
              </p>
            </div>
            <div className="mt-0 pe-1 d-flex">
              {isEdit ? (
                <>
                  <div
                    className={`left-col ${
                      !isEdit ? " w-50" : "w-50"
                    } text-start`}
                  >
                    <Typography
                      variant="body1"
                      gutterBottom
                      style={{ width: "80%" }}
                    >
                      <ContactDetailField
                        label="Packing Date"
                        isEdit={isEdit}
                        type="date"
                        value={formContent?.packingDate}
                        onChange={(e) => {
                          let values = { ...formContent };
                          values.packingDate = e.target.value;
                          setFormContent(values);
                        }}
                        minWidth={"125px"}
                      />
                    </Typography>
                  </div>
                  <div
                    className={`right-col ${
                      !isEdit ? "w-50 pe-5 " : "w-50 pe-2"
                    }  d-flex flex-column align-items-end justify-content-end text-end`}
                  >
                    <Typography
                      variant="body1"
                      className="text-start "
                      gutterBottom
                      style={{ width: "80%" }}
                    >
                      <ContactDetailField
                        label="Packing Time"
                        isEdit={isEdit}
                        type="time"
                        value={formContent?.packingTime}
                        onChange={(e) => {
                          let values = { ...formContent };
                          values.packingTime = e.target.value;
                          setFormContent(values);
                        }}
                        minWidth={"125px"}
                      />
                    </Typography>
                  </div>
                </>
              ) : (
                <>
                  <p className="mb-1">
                    {formContent?.packingDate} {formContent?.packingTime}
                  </p>
                </>
              )}
            </div>
          </div>
         
          {/* permissions */}
          <div className="mt-4 pe-1 no-print">
            <Typography variant="body1" className="text-start" gutterBottom>
              <DynamicCheckbox
                label="Is there any vehicle/crew permission/security access/permit required for your residence?"
                checkId1="check1"
                checkLabel1="Yes"
                checkId2="check2"
                checkLabel2="No"
                value1={formContent?.permissions}
                value2={formContent?.permissions}
                onChange1={(e) => {
                  let values = { ...formContent };
                  values.permissions = true;
                  setFormContent(values);
                }}
                onChange2={(e) => {
                  let values = { ...formContent };
                  values.permissions = false;
                  setFormContent(values);
                }}
                disabled={!isEdit ? true : false}
              />
            </Typography>
          </div>
          {/* /permissions */}
          {/* requirement */}
          {formContent?.permissions && (
            <div className="mt-4 pe-1 no-print">
              <Typography variant="body1" className="text-start" gutterBottom>
                <DynamicText
                  label="If yes, please advise requirement:"
                  textAreaLabel="Lorem ipsum"
                  isEdit={isEdit}
                  value={formContent?.adviseRequirement}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.adviseRequirement = e.target.value;
                    setFormContent(values);
                  }}
                />
              </Typography>
            </div>
          )}
          {/* /requirement */}
          {/* 1st priority */}
          <div className="mt-4 pe-1 no-print">
            <Typography variant="body1" className="text-start" gutterBottom>
              <DynamicText
                label="1st priority items to pack according to your need or requirement:"
                textAreaLabel="1st priority items..."
                isEdit={isEdit}
                value={formContent?.firstPriority}
                onChange={(e) => {
                  let values = { ...formContent };
                  values.firstPriority = e.target.value;
                  setFormContent(values);
                }}
              />
            </Typography>
          </div>
          {/* /1st priority */}
          {/* 2nd priority */}
          <div className="mt-4 pe-1 no-print">
            <Typography variant="body1" className="text-start" gutterBottom>
              <DynamicText
                label="2nd priority items to pack according to your need or requirement:"
                textAreaLabel="2nd priority items... "
                isEdit={isEdit}
                value={formContent?.secondPriority}
                onChange={(e) => {
                  let values = { ...formContent };
                  values.secondPriority = e.target.value;
                  setFormContent(values);
                }}
              />
            </Typography>
          </div>
          {/* /2nd priority */}
          {/* 3rd priority */}
          <div className="mt-4 pe-1 no-print">
            <Typography variant="body1" className="text-start" gutterBottom>
              <DynamicText
                label="3rd priority items to pack according to your need or requirement:"
                textAreaLabel="3rd priority items..."
                isEdit={isEdit}
                value={formContent?.thirdPriority}
                onChange={(e) => {
                  let values = { ...formContent };
                  values.thirdPriority = e.target.value;
                  setFormContent(values);
                }}
              />
            </Typography>
          </div>
          {/* /3rd priority */}
          {/* marked/labeled items */}
          <div className="mt-4 pe-1 no-print">
            <Typography variant="body1" className="text-start" gutterBottom>
              <DynamicCheckbox
                label="Residence’s rooms or items marked/labeled with suitable Info/Numbers/Colors are not going to pack up:"
                checkId1="labeled_items_yes"
                checkLabel1="Yes"
                checkId2="labeled_items_no"
                checkLabel2="No"
                value1={formContent?.packUpSuitable}
                value2={formContent?.packUpSuitable}
                onChange1={(e) => {
                  let values = { ...formContent };
                  values.packUpSuitable = true;
                  setFormContent(values);
                }}
                onChange2={(e) => {
                  let values = { ...formContent };
                  values.packUpSuitable = false;
                  setFormContent(values);
                }}
                disabled={!isEdit ? true : false}
              />
            </Typography>
          </div>
          {/* /marked/labeled items  */}
          {/* Customer Suggestions */}
          <div className="mt-4 pe-1 no-print">
            <Typography variant="body1" className="text-start" gutterBottom>
              <DynamicText
                label="Customer Suggestions/Remarks if any:"
                textAreaLabel="Customer Suggestions..."
                isEdit={isEdit}
                value={formContent?.suggestions}
                onChange={(e) => {
                  let values = { ...formContent };
                  values.suggestions = e.target.value;
                  setFormContent(values);
                }}
              />
            </Typography>
          </div>
          {/* /Customer Suggestions */}
          {/* Office Instructions/remarks */}
          <div className="mt-4 pe-1 mb-5 no-print">
            <Typography variant="body1" className="text-start" gutterBottom>
              <DynamicText
                label="Office Instructions/remarks:"
                textAreaLabel="Office Instructions/remarks..."
                isEdit={isEdit}
                value={formContent?.officeInstructions}
                onChange={(e) => {
                  let values = { ...formContent };
                  values.officeInstructions = e.target.value;
                  setFormContent(values);
                }}
              />
            </Typography>
          </div>
          {/* /Office Instructions/remarks */}

          {/* Signatures */}
          <Row className="my-5 pt-5 no-print">
            <Col sm={6} className="mt-5 pt-5">
              <div
                style={{ height: "90px" }}
                className="d-flex justify-content-center align-items-end"
              >
                {formContent?.moveCordinatorSign?.trim()?.length == 0 ? (
                  <>
                    {isEdit && (
                      <div className="d-flex justify-content-center align-items-end">
                        <label
                          htmlFor="uploadSign"
                          className="active-btn ms-2 w-200 d-flex align-items-center justify-content-center cursor-pointer btn"
                        >
                          {uploadText}
                        </label>
                        <input
                          type="button"
                          hidden
                          id="uploadSign"
                          name="uploadSign"
                          onClick={() => {
                            setSignCanvas(true);
                          }}
                        />
                      </div>
                    )}
                  </>
                ) : (
                  <div className="d-flex align-items-start">
                    <img
                      src={`${Bucket}${formContent?.moveCordinatorSign}`}
                      height={80}
                      width={200}
                    />
                    {isEdit && (
                      <>
                        <label
                          htmlFor="editSign1"
                          className=" ms-2  d-flex align-items-center justify-content-center cursor-pointer btn p-0"
                        >
                          <img
                            src={editIcn}
                            height={18}
                            width={18}
                            className="ms-2 cursor-pointer"
                          />
                        </label>
                        <input
                          type="button"
                          hidden
                          id="editSign1"
                          name="uploadSign"
                          onClick={() => {
                            setSignCanvas(true);
                          }}
                        />
                        <img
                          src={trashIcn}
                          height={18}
                          width={18}
                          className="ms-2 cursor-pointer"
                          onClick={() => {
                            let keysToDelete = [...mediaKeysToRemove];
                            keysToDelete.push(formContent?.moveCordinatorSign);
                            setMediaKeysToRemove(keysToDelete);

                            let values = { ...formContent };
                            values.moveCordinatorSign = "";
                            setFormContent(values);
                          }}
                        />
                      </>
                    )}
                  </div>
                )}
              </div>

              <p>{"_______________________________"}</p>
              <p className="my-1">
                <b>{"Move Coordinator"}</b>
              </p>

              {""}
            </Col>
            <Col sm={6} className="mt-5 pt-5">
              <div
                style={{ height: "90px" }}
                className="d-flex justify-content-center align-items-end"
              >
                <div className="d-flex align-items-center justify-content-center text-center">
                  {formContent?.clientSign?.trim()?.length > 0 && (
                    <img
                      src={`${Bucket}${formContent?.clientSign}`}
                      height={80}
                      width={200}
                    />
                  )}
                </div>
              </div>

              <p>{"_______________________________"}</p>
              <p className="my-1">
                <b>{"Client Signature"}</b>
              </p>

              {""}
            </Col>
          </Row>
         </PremiumCard>
         
          {/* snackbar */}
          <Snackbar
            open={openSnackbar}
            autoHideDuration={6000} // Adjust the duration as needed
            onClose={handleCloseSnackbar}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <MuiAlert
              elevation={6}
              variant="filled"
              severity={
                snackbarMessage?.includes("successful") ? "success" : "error"
              }
              onClose={handleCloseSnackbar}
            >
              {snackbarMessage}
            </MuiAlert>
          </Snackbar>

          {/* Add Role Modal */}
          {isShare && (
            <ShareWithClientsModal
              open={isShare}
              onClose={() => {
                setIsShare(false);
              }}
              onSuccess={(emails) => {
                shareWithClient(emails);
              }}
            />
          )}

          {/* Add signature Modal */}
          {isSignCanvas && (
            <MySignatureCanvas
              open={isSignCanvas}
              onClose={() => {
                setSignCanvas(false);
              }}
              onSuccess={(file) => {
                if (!isLoading) uploadFile(file);
              }}
            />
          )}

          {isVerified && (
            <SuperAdminVerifationModal
              open={isVerified}
              onClose={() => {
                setIsVerified(false);
              }}
              onSuccess={() => {
                setIsEdit(true);
                setIsVerified(false);
              }}
              onError={() => {
                // shareWithClient(emails);
                setSnackbarMessage("Invalid Confirm Pin");
                setOpenSnackbar(true);
              }}
            />
          )}

          <LoadingModal open={open} handleClose={handleClose} />
        </PremiumPageLayout>
      <PrintComponent>
        <PackingRequestPageDownload
          surveyData={surveyData}
          formContent={formContent}
        />
      </PrintComponent>
    </>
  );
};
export default PackingRequestPage;
